import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function RefundReport(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [refundData, setRefundData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

  useEffect(() => {
      fetchData();

  }, [startDate, endDate]);


  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}ip-refund-report-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios.get(url)
    .then(response => {
      setRefundData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }
    const rows = refundData.map((item, index) => {
    return {
      id: index + 1,
      date_time: `${item.add_date_date} ${item.add_time}`,
      ip__ip_id : item.ip__ip_id,
      ip__pat__pat_id: item.ip__pat__pat_id,
      ip__pat__patient: item.ip__pat__patient,
      receipt: item.receipt,
      refund_amount: item.refund_amount,
      receivedby: item.receivedby,
      reason: item.reason,
      addedby: item.addedby,
    };
    });

  const columns = [
    { field: 'date_time', headerName: 'Date', width: 150 },
    { field: 'ip__ip_id', headerName: 'IP ID', width: 50},
    { field: 'ip__pat__pat_id', headerName: 'Pat ID', width: 50},
    { field: 'ip__pat__patient', headerName: 'Patient', width: 150 },
    { field: 'receipt', headerName: 'Refund Receipt',
        renderCell: (params) => (
          <Link to={`/refund-invoice-ip/${params.row.receipt}`} target="_blank">
            {params.row.receipt}
          </Link>
      ),
      width: 120 },
    { field: 'refund_type', headerName: 'Refund Type', width: 100 },
    { field: 'refund_amount', headerName: 'Refund Amount', width: 100 },
    { field: 'receivedby', headerName: 'Received By', width: 100 },
    { field: 'reason', headerName: 'Reason', width: 100 },
    { field: 'addedby', headerName: 'Updated By', width: 100 },
  ];

  const getTotal = (rows, field) => {
    return rows.reduce((total, row) => total + parseFloat(row[field]), 0);
  };

   const Footer = ({ rows }) => {

      const totalRefundAmount = getTotal(rows, 'refund_amount');
      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
          <div>Total</div>
          <div>{totalRefundAmount}</div>
        </div>
      );
    };

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> IP Refund Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText={'Please select From date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />
         <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText={'Please select To date'}
            dateFormat="dd/MM/yyyy"
            showMonthDropdown
            showYearDropdown
         />

            </div>
          </div>
        </div>
      </div>

      {!isLoading && refundData.length > 0 ? (
        <div style={{ height: '100%', width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
              footer: () => <Footer rows={rows} />,
            }}
            autoHeight
          />
        </div>
      ) : (
        <></>
      )}
    </section>
  )
}

export default RefundReport;
